import React from 'react';


const UnderConstruction = () => {
  const wrapperStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
  };

  const boxStyle = {
    backgroundColor: '#ffffff',
    border: '2px solid #facc15',
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    maxWidth: '600px',
    width: '100%',
  };

  const headingStyle = {
    fontSize: '28px',
    color: '#333333',
    margin: '20px 0 10px',
  };

  const textStyle = {
    fontSize: '16px',
    color: '#555555',
  };

  const badgeStyle = {
    display: 'inline-block',
    marginTop: '20px',
    padding: '8px 16px',
    backgroundColor: '#fef9c3',
    color: '#92400e',
    fontWeight: 'bold',
    borderRadius: '999px',
    fontSize: '14px',
  };

  return (
    <div style={wrapperStyle}>
      <div style={boxStyle}>
        <h1 style={headingStyle}>🌍 Launching Soon in Your Country!</h1>
        <p style={textStyle}>
          We’re finalizing details to bring you the best experience. Thank you for your patience.
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;